export class Component {
    constructor(options){
        this.options = options
        this.output
        this.data
        this.element
        this.target
        this.init(options)
    }

    init(options){
        if(options.target) this.target =  ui.element(options.target)
        if(options.template) this.element = ui.template(options.template)
    }
    /**
     * Renders the component element from template and appends it to target
     * @param {{
    *    template : string,
    *    target : string
    * }} options
    */
    render(options = this.options){
        if(options.template)
            this.element = ui.template(options.template) // get template
        if(options.target)
            ui.element(options.target,this.element) // append to target element
        if(typeof options.onRender === 'function')
            options.onRender(this)
    }
    show(options){
        if(typeof options === 'object'){
            const targetElement = this.element.querySelector(options.target)
            this.element.querySelector(options.trigger).addEventListener(options.event ? options.event : 'click',(event)=>{
                targetElement.classList.remove('hide')
                targetElement.classList.add('show')
                targetElement.style.display = 'flex'
                event.target.remove() // remove button
                if(typeof options.callback === 'function')
                    options.callback(targetElement)
            })
        }
    }
}
